// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import BillingController from "./billing_controller"
application.register("billing", BillingController)

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)

import CookieConsentController from "./cookie_consent_controller"
application.register("cookie-consent", CookieConsentController)

import DemoVideoController from "./demo_video_controller"
application.register("demo-video", DemoVideoController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import ReferralNudgeController from "./referral_nudge_controller"
application.register("referral-nudge", ReferralNudgeController)

import SupportChatController from "./support_chat_controller"
application.register("support-chat", SupportChatController)

import ThemeController from "./theme_controller"
application.register("theme", ThemeController)
